import { useState, useEffect } from "react";
import SaveAndEditCamModal from "./SaveAndEditCamModal.tsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getStockCams, deleteStockCam, updateStockCam, createStockCam, getStockCam, cleanStockCams } from '../api/stockCams.api';
import { SquarePen, FileMinus, Trash } from "lucide-react";
import {CamHardWare} from "../model/StockCam";



const StockCamTable = () => {
    
    const [stockCams, setStockCams] = useState<CamHardWare[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStockCam, setSelectedStockCam] = useState<CamHardWare | null>(null);

    
    
    const [loading, setLoading] = useState(true);
    const [editingCamara, setEditingCamara] = useState(null);

    const fetchStockCams = async () => {
      try {
        const data = await getStockCams();
        setStockCams(data);
      } catch (error: any) {
        setError(error.message || "Error al obtener las cámaras del stock");
      } finally {
        setLoading(false);
      }

    };

   useEffect(() => {
    fetchStockCams();
  }, []);

  
const openModal = (stockCamId?: string) => {
      console.log("stockCamId:", stockCamId);

  if (stockCamId) {
    const selected = stockCams.find(stockCam => stockCam.id === stockCamId);
    if (selected) {
      setSelectedStockCam(selected);
      setIsModalOpen(true);
    }
  } else {
    setSelectedStockCam(null); 
    setIsModalOpen(true);
  }
};

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStockCam(null);
    fetchStockCams();
  };

  const handleClean = async (id: string) => {
    if (window.confirm("¿Estás seguro de que quieres limpiar este registro?")) {
      try {
        setLoading(true);
        await cleanStockCams(id);
        toast.success("Registro limpiado correctamente");
        fetchStockCams();
      } catch (error: any) {
        console.error(error);
        toast.error("Error al limpiar el registro");
        setLoading(false);
      }
    }
  };
      
  const handleDelete = async (id: string) => {
    if (window.confirm("¿Estás seguro de que quieres eliminar este registro? Esta acción no se puede deshacer.")) {
      try {
        setLoading(true);
        await deleteStockCam(id);
        toast.success("Registro eliminado correctamente");
        fetchStockCams();
      } catch (error: any) {
        console.error(error);
        toast.error("Error al eliminar el registro");
        setLoading(false);
      }
    }
  };



    return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Altas y Edicion de Stock de Camaras</h1>
        <div className="flex gap-4">
          <div className="dropdown-container">
            
          </div>
        </div>
      </div>

      <button
        onClick={() => openModal(undefined)}
        className="mt-6 bg-green-500 text-white px-6 py-3 rounded-md shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center gap-2 ml-auto"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
        </svg>
        Agregar Nuevo Camara al Stock
      </button>
      <br/>


      {/*error && (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          </div>
        </div>
      )*/}

      {/*success && (
        <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-green-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-green-700">{success}</p>
            </div>
          </div>
        </div>
      )*/}


      {loading ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
      ) : stockCams.length === 0 ? (
        <div className="text-center py-10 text-gray-500">
          No hay camaras disponibles en el stock.
        </div>
      ) : (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
<table className="min-w-full divide-y divide-gray-200 border-collapse" style={{ borderSpacing: '0 1px' }}>


<thead className="bg-gray-50 text-sm">
  <tr>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Cliente
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Camara
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Marca
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      UID/SERIAL
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Modelo
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Tipo
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      PWD
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Propietario
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Status
    </th>
    <th className="px-2 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">
      Edit
    </th>
  </tr>
</thead>

<tbody className="bg-white divide-y divide-gray-200 text-sm">
  {stockCams.map(stockCam => (
    <tr key={stockCam.id}>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.customerId}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.camIdentifier}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.brand}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.serialNumber}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.model}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.type}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.pwd}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">{stockCam.owner}</td>
      <td className="px-2 py-2 text-gray-700 whitespace-nowrap">
          <div className={`w-4 h-4 rounded-full ${stockCam.status ? 'bg-green-500' : 'bg-red-500'}`}></div>
      </td>
      <td className="px-2 py-2 whitespace-nowrap">
        <div className="flex items-center gap-3">
          <button
            onClick={() => {
              openModal(stockCam.id);
              console.log("stockCam.id!!!!!!!:", stockCam.id);
            }}
            className="p-3.5 lg:p-0 text-gray-600 hover:text-blue-600"
            title="Editar"
          >
            <SquarePen className="w-4 h-4"/>
          </button>
          <button
            onClick={() => stockCam.id && handleClean(stockCam.id)}
            className="p-3.5 lg:p-0 text-gray-600 hover:text-orange-600"
            title="Limpiar"
          >
            <FileMinus className="w-4 h-4"/>
          </button>
          <button
            onClick={() => stockCam.id && handleDelete(stockCam.id)}
            className="p-3.5 lg:p-0 text-gray-600 hover:text-red-600"
            title="Eliminar"
          >
            <Trash className="w-4 h-4"/>
          </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>
          </table>
        </div>
      )}

      {isModalOpen && (
        <SaveAndEditCamModal 
          isOpen={isModalOpen} 
          onClose={closeModal}
          stockCam={selectedStockCam ?? undefined}
        />
      )}
      
      <ToastContainer />
    </div>
  );
};


export default StockCamTable
